export const ShopAllLink = "https://safetagtracking.com/collections/shop-all";
export const SupportLink = "https://safetagtracking.com/pages/support";
export const TermsOfServiceLink =
  "https://safetagtracking.com/policies/terms-of-service";
export const PrivacyPolicyLink =
  "https://safetagtracking.com/policies/privacy-policy";
export const PricingLink = "https://safetagtracking.com/pages/pricing-page";
export const ContactLink = "https://safetagtracking.com/pages/contact";
export const ContactSupportLink =
  "https://safetagtracking.com/pages/contact?reason=support";
export const ContactBusinessLink =
  "https://safetagtracking.com/pages/contact?reason=business";
export const ContactQueryLink =
  "https://safetagtracking.com/pages/contact?reason=query";
export const ContactGeneralLink =
  "https://safetagtracking.com/pages/contact?reason=general";
export const WiredTrackersLink =
  "https://safetagtracking.com/pages/wired-trackers";
export const WirelessTrackersLink =
  "https://safetagtracking.com/pages/wireless-trackers";
export const AssetTrackingLink =
  "https://safetagtracking.com/pages/asset-tracking";
export const ShareLink = "https://app.safetagtracking.com/share/";
export const ReferralSignupLink =
  "https://app.safetagtracking.com/signup?referred_by=";
export const APIDocsLink =
  "https://docs.safetagtracking.com/reference/getting-started-with-your-api";

export const AppStoreLink =
  "https://apps.apple.com/us/app/safetag-tracking/id1644524830";

export const PlayStoreLink =
  "https://play.google.com/store/apps/details?id=com.downriver.safetag";

export const EmailSupportLink =
  "mailto:support@safetagtracking.com";

export const EmailAddress = "support@safetagtracking.com";